const HEALTH_CHECK_ENDPOINT = `${import.meta.env.VITE_API_URL}/endpoints/health`;

export const checkHealth = async (): Promise<boolean> => {
  try {
    const response = await fetch(HEALTH_CHECK_ENDPOINT);
    return response.ok;
  } catch (error) {
    console.error('Health check failed:', error);
    return false;
  }
};
